import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { initialize } from './actionCreators';
import { getIsInitialized, getTooltipState } from './selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { startNewChatWithParticipant } from '../../Chat/redux/actions';
const mapStateToProps = (state, ownProps)=>{
    const { username  } = ownProps;
    const currentUser = getCurrentUser(state);
    return _object_spread({
        isInitialized: getIsInitialized(state, username),
        isOwner: currentUser && currentUser.username === username
    }, getTooltipState(state, username));
};
const mapDispatchToProps = (dispatch)=>({
        initialize: (username)=>dispatch(initialize(username)),
        onStartChat: (user)=>dispatch(startNewChatWithParticipant(uniqueId('new-chat-request'), {
                id: user.useridUuid,
                name: user.username
            }))
    });
export default connect(mapStateToProps, mapDispatchToProps);
